var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconchatLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#E7E7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1129 13.8745C10.6839 13.8745 10.2564 13.8047 9.8428 13.6666L9.83199 13.6636H9.80884C9.38599 13.8063 8.9585 13.8761 8.5233 13.8761C6.35038 13.8745 4.58334 12.1371 4.58334 10.0005C4.58334 7.86398 6.35038 6.12652 8.5233 6.12652C8.95233 6.12652 9.37982 6.19632 9.79341 6.33441L9.80421 6.33744H9.82736C10.2502 6.1948 10.6777 6.125 11.1114 6.125C13.2843 6.125 15.0513 7.86246 15.0513 9.99901C15.0513 12.1356 13.2843 13.873 11.1114 13.873L11.1129 13.8745ZM12.4633 10.0005C12.4633 11.0642 12.0327 12.0551 11.2503 12.7926L11.1114 12.9246L11.3043 12.9125C12.8614 12.8139 14.0806 11.5347 14.0806 10.0005C14.0806 8.4664 12.7503 7.0825 11.1129 7.0825C10.2055 7.0825 9.35975 7.48462 8.79183 8.18568L8.70695 8.29038L8.84276 8.29948C9.18999 8.32224 9.51099 8.45274 9.77181 8.67884L9.8181 8.71981L9.8644 8.67884C10.1499 8.4315 10.5157 8.29493 10.8968 8.29493C11.721 8.29493 12.4077 8.92922 12.4586 9.73953L12.4633 9.80174V10.002V10.0005ZM8.33194 7.08857C6.77478 7.1872 5.5556 8.4664 5.5556 10.0005C5.5556 11.5347 6.88744 12.9186 8.5233 12.9186C8.87054 12.9186 9.21469 12.8579 9.54803 12.7365L9.72088 12.6682C10.7965 12.2008 11.4925 11.1538 11.4925 10.0005V9.83361C11.4925 9.51191 11.2256 9.2494 10.8984 9.2494C10.5712 9.2494 10.3058 9.51191 10.3058 9.83513V11.6378H9.33352V9.83513C9.33352 9.78202 9.32426 9.72587 9.30574 9.66517C9.29802 9.63634 9.29339 9.62269 9.28722 9.60903L9.27796 9.59082C9.26098 9.55744 9.24864 9.53316 9.23321 9.5104L9.21932 9.4937C9.20234 9.47094 9.18382 9.44666 9.16067 9.4239L9.14524 9.41025C9.119 9.38748 9.0974 9.36927 9.07579 9.3541C9.06499 9.34651 9.05419 9.34044 9.04338 9.33589L9.02332 9.32375C9.00943 9.31616 8.99554 9.30706 8.98011 9.30099C8.9585 9.29189 8.9369 9.2843 8.91375 9.27823C8.88751 9.26912 8.8798 9.26761 8.87208 9.26609C8.84585 9.26002 8.81807 9.25698 8.78874 9.25547C8.7656 9.25243 8.75634 9.25091 8.74862 9.25091C8.4662 9.25091 8.21928 9.44666 8.16218 9.71373C8.15138 9.81388 8.14675 9.90948 8.14675 10.002V11.6394H7.17449V10.002C7.17449 8.93984 7.60506 7.94744 8.3875 7.20997L8.52639 7.07795L8.33348 7.09009L8.33194 7.08857Z",
    fill: "url(#paint0_linear_489_3332)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_489_3332",
    x1: 4.58334,
    y1: 10.0005,
    x2: 15.0529,
    y2: 10.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5368DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#9D509F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#BF4683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A44680"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconchatLogo);
export default __webpack_public_path__ + "static/media/icon.chat_logo.738718e2e34401cf365805681ef1426a.svg";
export { ForwardRef as ReactComponent };